import { render, staticRenderFns } from "./EmbedContentModal.vue?vue&type=template&id=c80fa8de"
import script from "./EmbedContentModal.vue?vue&type=script&lang=js"
export * from "./EmbedContentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports